import { render, staticRenderFns } from "./MessagingBoxButton.vue?vue&type=template&id=7079efa0"
import script from "./MessagingBoxButton.vue?vue&type=script&lang=js"
export * from "./MessagingBoxButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports